var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M29 16L5 32V0z"}));
}

Play.defaultProps = {"width":"32","height":"32","aria-label":"Play","viewBox":"0 0 32 32"};

module.exports = Play;

Play.default = Play;
